import { InviteAcceptPage } from '@/features/invites/InviteAcceptPage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/invite/accept/$inviteId/')({
    component: InviteAcceptPage,
});
